import React, { forwardRef } from 'react';

const CustomInput = forwardRef(({ error, ...props }, ref) => {
	return (
		<input
			ref={ref}
			{...props}
			className={`form-control ${ error ? 'error' : '' }`}
		/>
	);
});

export default CustomInput;
